<template>
<div class="content-main">
    <div class="left-main">
        <div class="left-main-content">
            <div class="title"><span class="colorFB092B">金融</span><span>服务</span></div>
            <div class="sec-title">全球线上外贸综合服务系统为出口工厂提供通关、结汇、退税、物流和金融等全程流程、一站式的线上外综综合服务。<br>
                通过规模效应、缩减换件、减少操作，全面降低工厂出口交易成本，提升用户体验，让工厂专心接单生产，助力川货出川。 </div>
            <div class="text-video-box">
                <div class="left-nav-box">
                    <div :class="{'nav-child':true,'active-nav':item.isClick}" v-for="(item,index) in navList" :key="index" @mouseover="changeNav(item)">
                        <div class="child-left">
                            <div class="line" v-if="item.isClick==true"></div>
                            <div class="triangle" v-else></div>
                            <div class="child-text">{{item.text}}</div>
                        </div>
                        <div class="imgs">
                            <img :src="item.icon" alt="" width="100%" height="100%" v-if="item.isClick">
                        </div>
                    </div>
                </div>
                <div class="right-child-box" v-for="(item,index) in navList" :key="index" v-if="item.id==0&&item.isClick">
                    <div class="childList showBox" index="1">
                        <div class="child-title">服务内容</div>
                        <ul class="serverList_1">
                            <li>√ 申请门槛低，融资金额和订单数量无限制；</li>
                            <li>√ 单证齐全后，最快3个工作日到账；</li>
                            <li>√ 盘活资金，无需关注复杂的退税环节。</li>
                        </ul>
                        <div class="child-title">服务流程</div>
                        <div class="server-img-box"> <img id="" src="../assets/images/pic_22.png" alt="" class="server-img" width="50%" height="100%"></div>
                        <div class="child-title">准入条件</div>
                        <div>
                            <ul class="serverList_2">
                                <li>◆ 申请企业需是生产型一般纳税人企业；</li>
                                <li>◆ 通过我平台出口报关（以海关报关单为准）；</li>
                                <li>◆ 我平台收到全额外汇；</li>
                                <li>◆ 我平台收到合规的增值税专用发票。</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="right-child-box" v-for="(item,index) in navList" :key="index" v-if="item.id==1&&item.isClick">
                    <div class="childList" index="2" style="display: block;">
                        <div class="child-title">服务内容</div>
                        <ul class="serverList_1">
                            <li>√ 解决企业原材料资金短缺，提高客户接单能力；</li>
                            <li>√ 企业根据赊销合同和真实有效的购货订单即可申请；</li>
                            <li>√ 我平台在买方授信额度内垫付相应的订单金额。</li>
                        </ul>
                        <div class="child-title">服务流程</div>
                        <div class="server-img-box"> <img id="" src="../assets/images/pic_25.png" alt="" class="server-img" width="40%" height="50%"></div>
                        <div class="child-title">准入条件</div>
                        <div>
                            <ul class="serverList_2">
                                <li>◆ 买方通过中信保额度审核，卖方与我平台签订外贸托管协议；</li>
                                <li>◆ 卖方在外综云服有历史交易收汇记录；</li>
                                <li>◆ 买方授信额度内最高垫付订单金额的60%。</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="right-child-box" v-for="(item,index) in navList" :key="index" v-if="item.id==2&&item.isClick">
                    <div class="childList" index="3" style="display: block;">
                        <div class="child-title">服务内容</div>
                        <ul class="serverList_1">
                            <li>√ 服务涵盖信用证基础服务、 信用证买断服务两大模块，可按需灵活选取；</li>
                            <li>√ 综合性的金融服务方案，任何涉及信用证交易的企业均适用。</li>
                        </ul>
                        <div class="child-title">服务流程</div>

                        <div class="server-img-box">
                            <p>◆ 信用证基础服务流程：</p>
                            <img id="" src="../assets/images/pic_27.png" alt="" class="server-img" width="50%">
                        </div>
                        <div class="server-img-box">
                            <p>◆ 信用证买断服务流程：</p>
                            <img id="" src="../assets/images/pic_28.png" alt="" class="server-img" width="50%">
                        </div>
                        <div class="child-title">准入条件</div>
                        <div>
                            <ul class="serverList_2">
                                <li>◆ 客户需是采取国际信用证结算的外贸出口企业，满足我平台合作要求（即完成至少一单外综云服的出口退税业务）；</li>
                                <li>◆ 企业如需信用证融资买断服务，需开立受益人是外综云服的信用证（信用证类型为不可更改不可撤销），且企业需成立半年以上, 近6个月至少有一笔自营信用证收汇记录；</li>
                                <li>◆ 开具信用证国家需在中信保评级B级以上，对于B级以下的国家或地区必须由我司指定的国际性银行作为开证方。</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="right-child-box" v-for="(item,index) in navList" :key="index" v-if="item.id==3&&item.isClick">
                    <div class="childList" index="4" style="display: block;">
                        <div class="child-title">服务内容</div>
                        <ul class="serverList_1">
                            <li>√ 以出口额度积累授信额度的无抵押、免担保、纯信用贷款，真正实现“信用=财富”；</li>
                            <li>√ 申请授信额度全程免费，1年有效期内，可根据资金需求随时支用，不支用永不收费。</li>
                        </ul>
                        <div class="child-title">服务流程</div>
                        <div class="server-img-box"> <img id="" src="../assets/images/pic_30.png" alt="" class="server-img" width="50%"></div>
                        <div class="child-title">准入条件</div>
                        <div>
                            <ul class="serverList_2">
                                <li>◆ 申请企业需是我平台托管合作企业（在我平台上运行一年以上且交易金额在50万美元以上），出口一美元享受最高一元人民币的贷款额度，最高不超过200万；</li>
                                <li>◆ 申请企业未被列入各金融机构违约客户黑名单中，无重大环保、债务、税务等纠纷，且企业主营业务不属于国家禁止和限制的行业；</li>
                                <li>◆ 实际控制人愿意签署无限连带担保合同；</li>
                                <li>◆ 申请企业工商注册年限2年以上。</li>
                            </ul>
                        </div>

                    </div>
                </div>
                <div class="right-child-box" v-for="(item,index) in navList" :key="index" v-if="item.id==4&&item.isClick">
                    <div class="childList" index="5" style="display: block;">
                        <div class="child-title">服务内容</div>
                        <ul class="serverList_1">
                            <li>√ 通过我平台出口并委托我平台投保；</li>
                            <li>√ 掌握买家真实情况，规避政治风险和外汇风险。</li>
                        </ul>
                        <div class="child-title">服务流程</div>
                        <div class="server-img-box"> <img id="" src="../assets/images/pic_32.png" alt="" class="server-img" width="50%"></div>
                        <div class="child-title">准入条件</div>
                        <div>
                            <ul class="serverList_2">
                                <li>◆ 经我平台审核通过入驻我平台的企业，商品和开票人备案通过；</li>
                                <li>◆ 向我平台提供买方（开证行）相关信息；</li>
                                <li>◆ 限额申请时效：最快3个工作日（信保系统已有资信调查报告时）；最快7个工作日 （无现有资信报告，需启动海外调查渠道时）。</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

    <div class="right-main">
        <div class="tagLabel-box">
            <div class="label-top">
                <div :class="{'icon-item':true,'active-icon':item.hasClass}" v-for="(item,index) in list" :key="index" :style="{backgroundImage: `url(${item.hasClass?active_icon:default_icon})`}" @click="changeTag(item)"></div>
            </div>
            <div class="label-bottom">
                <div class="label-bottom-top">
                    <div :class="{'active-child':item.hasClass,'default-child':true}" v-for="(item,index) in list" :key="index" @click="changeTag(item)"></div>
                </div>
                <div class="label-bottom-bottom">
                    <img src="../assets/images/icon_1.png" alt="" width="27px" height="37px">
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import top_active from "../assets/images/top_active.png"
import top_default from "../assets/images/top_default.png"
import icon_9 from '@/assets/images/icon_9.png'
import icon_10 from '@/assets/images/icon_10.png'
import icon_11 from "@/assets/images/icon_11.png"
import icon_12 from '@/assets/images/icon_12.png'
import icon_13 from '@/assets/images/icon_13.png'
export default {
    name: "tagFin",
    props: {
        "vdata": {
            type: Array,
            default: [],
        }

    },
    data() {
        return {
            list: [],
            navList: [{
                    id: 0,
                    text: "出口退税垫付",
                    isClick: true,
                    icon: icon_13
                },
                {
                    id: 1,
                    text: "订单融资",
                    isClick: false,
                    icon: icon_9,
                }, {
                    id: 2,
                    text: "信用证服务",
                    isClick: false,
                    icon: icon_10
                }, {
                    id: 3,
                    text: "流水贷",
                    isClick: false,
                    icon: icon_11
                }, {
                    id: 4,
                    text: "出口信用保险",
                    isClick: false,
                    icon: icon_12
                }
            ],
            default_icon: top_default,
            active_icon: top_active
        }
    },
    created() {
        let curr = this.vdata;
        let result = [];
        //console.log(curr,"curr")
        curr.forEach((item, index) => {
            if (index % 2 == 0) {
                result.push(item);
            }
        })
        this.list = result;
        console.log(this.list, "vdata")
    },
    methods: {
        changeNav(temp) {
            this.navList.forEach((item, index) => {
                if (item.id == temp.id) {
                    this.$set(this.navList, index, {
                        id: item.id,
                        text: item.text,
                        isClick: true,
                        icon: item.icon
                    })
                } else {
                    this.$set(this.navList, index, {
                        id: item.id,
                        text: item.text,
                        isClick: false,
                        icon: item.icon
                    })
                }
            })
        },
        changeTag(item) {
            let curr = this.vdata;
            curr.forEach((tem, index) => {
                console.log(tem.id, item.id)
                if (tem.id == item.id) {
                    console.log(11111)
                    curr[index] = {
                        id: tem.id,
                        text: tem.text,
                        isText: tem.isText,
                        isShow: tem.isShow,
                        hasClass: true,
                    }
                } else {
                    curr[index] = {
                        id: tem.id,
                        text: tem.text,
                        isText: tem.isText,
                        isShow: tem.isShow,
                        hasClass: false,
                    }
                }
            })
            let result = [];
            curr.forEach((item, index) => {
                if (index % 2 == 0) {
                    result.push(item);
                }
            })
            this.list = result;
            this.$emit('godata', {
                item,
                index: item.id
            })
            console.log(curr, "curr")
        }
    }

}
</script>

<style lang="less" scoped>
.active-icon {
    width: 22px !important;
    height: 22px !important;
}

.content-main {
    //background-color: yellowgreen;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    .left-main {
       width: 100%;
       height: 100%;
       display: flex;
       justify-content: center;
       align-items: center;
        .left-main-content{
        width: 1440px;
        height: 100%;
        height: 100%;
        //background-color: #ccc;
        // padding-left: 240px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        }
    }

    .right-main {
        width: 30px;
        position: absolute;
        top: 0;
        right: 0;
        height: 100%;
        padding-right: 60px;

        //background-color: rgb(167, 164, 164);
        display: flex;
        justify-content: flex-end;
        align-items: center;

        .tagLabel-box {
            width: 40px;
            height: 100%;
            // margin-top: 160px;
            //border: 1px red solid;
            display: flex;
            justify-content: space-around;
            align-items: center;
            flex-direction: column;

            .label-top {
                width: 100%;
                height: 30%;
                display: flex;
                justify-content: space-around;
                align-items: center;
                flex-direction: column;

                //border: 1px green solid;

                .icon-item {
                    width: 8px;
                    height: 8px;
                    background-size: cover;
                    background-position: center center;
                }
            }

            .label-bottom {
                width: 100%;
                height: 30%;
                //border: 1px green solid;

                .label-bottom-top {
                    width: 100%;
                    height: 80%;
                    //border: 1px red solid;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex-direction: column;
                }

                .label-bottom-bottom {
                    width: 100%;
                    height: 20%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    //border:1px red solid;
                }
            }
        }
    }
}

.colorFB092B {
    color: #FB092B;
}

.title {
    margin-top: 50px;
    color: #fff;
    font-size: 60px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    line-height: 84px;
}

.sec-title {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.75);
    line-height: 26px;
}

.text-video-box {
    margin-top: 50px;
    display: flex;
    flex: 1;
    //border: 1px red solid;
    //min-height: 360px;
    justify-content: flex-start;
    align-items: flex-start;

    .left-nav-box {
        width: 30%;
        //height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: column;

        //border: 1px red solid;
        .nav-child {
            width: 80%;
            height: 100px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            //border: 1px red solid;
            padding-right: 30px;

            .child-left {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                height: 100%;

                .line {
                    width: 4px;
                    height: 40px;
                    background: #FFFFFF;
                    margin-right: 36px;
                }

                .triangle {
                    width: 0;
                    height: 0;
                    border-top: 6px solid transparent;
                    border-left: 12px solid rgba(255, 255, 255, 0.5);
                    border-bottom: 12px solid transparent;
                    margin-right: 36px;
                }

                .child-text {
                    font-size: 24px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #FFFFFF;
                    line-height: 33px;
                }
            }

            .imgs {
                width: 46px;
                height: 46px;
            }
        }
    }

    .right-child-box {
        width: 70%;
        //height: 100%;
        background: #FFFFFF;
        margin-right: 50px;

        border-radius: 0px 16px 0px 16px;

        .childList {
            width: 90%;
            //padding: 50px;
            padding-top: 20px;
            padding-left: 50px;
            //padding: 20px;
            padding-bottom: 20px;
            padding-right: 50px;
            //border:1px red solid;

            .child-title {
                width: 100%;
                font-size: 20px;
                padding-left: 15px;
                line-height: 30px;
                /* background-color: #333; */
                border-left: 5px #b62020 solid;
                /* margin-left: 20px; */
                color: #333;
                margin-bottom: 15px;
                font-weight: bold;
                margin-top: 25px;
            }

            .server-img-box {
                width: 100%;
                margin-bottom: 10px;
            }

            .serverList_1 {
                list-style-type: none;
                margin-bottom: 10px;
                color: #333;
                font-size: 16px;
                line-height: 2;
            }

            .serverList_2 {
                list-style-type: none;
                color: #333;
                font-size: 16px;
                line-height: 2;
            }
        }
    }
}

.video-box {
    width: 45%;
    min-width: 640px;
    height: 70%;
    border: 1px red solid;
    display: flex;
    min-height: 360px;
    justify-content: center;
    align-items: center;
}

.active-nav {
    background: linear-gradient(135deg, rgba(182, 32, 32, 0.8) 0%, rgba(255, 255, 255, 0.1) 100%);
    border-radius: 0px 16px 0px 16px;
    width: 100%;
}

.text-box {
    width: 45%;
    min-width: 640px;
    height: 70%;
    min-height: 360px;
    //border: 1px red solid;
    padding: 0 20px;

}

.text-title {
    font-size: 30px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FB092B;
    line-height: 42px;
    margin-bottom: 40px;
}

.text {
    width: 640px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.85);
    text-align: justify;
    line-height: 32px;
}

.mgb40 {
    margin-bottom: 40px;
}

.btn-go {
    width: 32px;
    height: 32px;
    background-color: #CC1F37;
    margin-top: 40px;
}

.default-child {
    width: 2px;
    height: 16%;
    background: rgba(255, 255, 255, 0.1);
}

.active-child {
    background: rgba(54, 169, 255, 0.5);
}
</style>



// WEBPACK FOOTER //
// src/components/tagFin.vue